module.exports = __webpack_public_path__ + "img/cart-none.f2ca15ea.png";